import useThirdPartyScriptEndpoints from '@/composables/api/useThirdPartyScriptEndpoints';

const { getRiskifiedSession } = useThirdPartyScriptEndpoints();
const storeDomain = 'banxa.com';
const riskifiedBaseUrl = 'beacon.riskified.com';

const loadRiskifiedScript = (sessionId) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;

  script.onload = () => {
    console.log('Riskified script loaded successfully');
  };

  script.onerror = (error) => {
    console.error('Error loading Riskified script:', error);
  };

  script.src = `${(document.location.protocol === 'https:' ? 'https://' : 'http://')
  + riskifiedBaseUrl}?shop=${storeDomain}&sid=${sessionId}`;

  document.head.appendChild(script);
};

async function initializeRiskified() {
  try {
    const response = await getRiskifiedSession();
    if (response?.sessionId) {
      loadRiskifiedScript(response.sessionId);
    } else {
      console.error('No sessionId received from Riskified.');
    }
  } catch (error) {
    console.error('Error initializing Riskified:', error);
  }
}
initializeRiskified();
